import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'kustomer.chat.describe.email.title',
    description: 'Notify by email title',
    defaultMessage: "Don't miss a response! Get notified by email:",
  },
  placeholder: {
    id: 'kustomer.chat.describe.email.placeholder',
    description: 'Notify by email placeholder',
    defaultMessage: 'example@domain.com',
  },
  success_message: {
    id: 'kustomer.chat.describe.email.success',
    description: 'Notify by email success message',
    defaultMessage: "Thanks! We'll update you here and by email to",
  },
  failure_message: {
    id: 'kustomer.chat.describe.email.failure',
    description: 'Notify by email success message',
    defaultMessage: 'Please enter a valid email',
  },
});
